<template>
  <div id="ccLogin">
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
      <div class="row">
        <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-md-6 offset-md-3"
          style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:150px; padding:50px 0 50px 0; border-radius: 15px;">

          <div class="row">
            <div class="col-10 offset-1">

              <!-- <h1 class="text_cinza text-center">DEPOSITO</h1> -->

              <div v-if="layout1">
                <label class="text_branco">Nome</label>
                <div class="input-group mb-4">
                  <input type="text" v-model="nome" class="form-control">
                </div>

                <label class="text_branco">CPF</label>
                <div class="input-group mb-4">
                  <input type="text" v-model="cpf" class="form-control">
                </div>

                <label class="text_branco">Valor R$</label>
                <div class="input-group mb-4">
                  <input type="text" v-model="valor" class="form-control">
                </div>

                <button class="btn btn-outline-success w-100 btn-sm mt-3" @click="depositoOKTO()">Depositar</button>
              </div>

              <div class="row" v-show="layout2">
                <!--
                <div class="col-md-12 text_branco mb-3 text_25 text_bold"> Enviar R$ {{ valor }} para: </div>
                <div class="col-md-12 text_branco mb-1 text_20"> Okto Pagamentos S.A. </div>
                <div class="col-md-12 text_branco mb-3 text_20"> 44.783.669/0001-72 </div>

                <div class="col-md-12 text_branco mb-3 text_25 text_bold"> Instruções: </div>
                <div class="col-md-12 text_branco mb-1 text_20"> Vencimento: {{ created }}</div>
                <div class="col-md-12 text_branco mb-3 text_20"> Pagável até: {{ due }}</div>
                -->

                <div class="col-md-12 text-center text_branco mb-4">
                  <img :src=qrcodeData alt="Responsive image" :title='"sokkerduel"' width="180px">
                </div>
                <div class="col-md-12 text-center text_branco text_25 mb-3">
                  Valor: R$ {{ valor }}
                </div>

                <div class="col-12 text-center text_branco mb-3">
                  <input type="text" ref="copiar" v-model="link"> <br><br>
                </div>

                <div class="col-8 offset-2 text-center text_branco mb-3">
                  <button class="btn btn-primary w-100" @click="copy()"> Copiar QR Code</button>
                </div>

                <!--
                <div class="col-8 offset-2 text-center text_branco mb-4">
                  <a :href="link" class="btn btn-info w-100" target="_blank"> Baixar PDF </a>
                </div>

                <div class="col-8 offset-2 text_branco text-center mb-3 text_20"> Dados para PIX manual </div>
                <div class="col-8 offset-2 text_branco mb-2 text_15"> Nome: Okto Pagamentos S.A. </div>
                <div class="col-8 offset-2 text_branco mb-2 text_15"> CNPJ: 44.783.669/0001-72 </div>
                <div class="col-8 offset-2 text_branco mb-2 text_15"> Banco: Stark Bank S.A. (20018183) </div>
                <div class="col-8 offset-2 text_branco mb-2 text_15"> Agência: 0002 </div>
                <div class="col-8 offset-2 text_branco mb-2 text_15"> Conta: 6239 5546 3372 8000 </div>
                -->
              </div>

            </div>

          </div>
        </div>




      </div>
    </div>
  </div>
</div></template>

<script>

import axios from 'axios'
import { TheMask } from 'vue-the-mask'
import QRCodeVue from 'vue-qrcode-component';
import QRCode from 'qrcode';
import ccLoading from '../cc_geral/cc_loading.vue'

export default {

  data() {
    return {
      user: {},
      loading: false,
      errors: [],
      base_url_api: process.env.BASE_URL_API,
      nome: "",
      cpf: "",
      valor: '7,35',
      created: null,
      due: null,
      brcode: null,
      link: 'null slkfjslkdfj',
      money: '',

      layout1: true,
      layout2: false,

      qrcodeData: 'Seu dado para o QR code aqui', // Pode ser uma variável ou uma string fixa
      qrcodeOptions: {
        version: 10, // Ajuste conforme necessário
      },
    }
  },

  components: { TheMask, QRCodeVue, ccLoading },

  created() {
    localStorage.setItem("base_url_api_mobile", this.base_url_api);

    console.log(new Date())
  },

  methods: {

    depositoOKTO() {
      
      /*
      this.loading = true

      this.brcode = "00020101021226790014br.gov.bcb.pix2557brcode.starkinfra.com/v2/6cd951e8112743bfa5d9c9c4a32f726d5204000053039865802BR5920Okto Pagamentos S.A.6009Sao Paulo62070503***6304E1C0"

      QRCode.toDataURL(this.brcode, (err, url) => {
        if (err) throw err;
        this.qrcodeData = url;
      });

      this.layout1 = false
      this.layout2 = true
      this.loading = false
      return
      */

      let v = this.valor.replace(/,/g, '.')

      var body = {
        name: this.nome,
        taxId: this.cpf,
        amount: v * 100,
        expiration: 3600,
        tags: [
          'Operator-3005376515'
        ],
      }

      var header = { 'headers': { 'Authorization': this.token, } }
      axios.post('https://tt2.sokkerduel.co.uk/teste', body, header)
      // axios.post('http://localhost:3000/teste', body, header)
        .then(response => {

          if (response.status == 200) {
            console.log(response.data)

            this.name = response.data.name
            this.taxId = response.data.taxId
            this.amount = response.data.amount
            this.status = response.data.status
            this.created = response.data.created
            this.due = response.data.due
            this.pdf = response.data.pdf
            this.link = response.data.link
            this.brcode = response.data.brcode

            this.layout1 = false
            this.layout2 = true
            this.loading = false

            QRCode.toDataURL(this.brcode, (err, url) => {
              if (err) throw err;
              this.qrcodeData = url;
            });
          }

        })
        .catch(e => {
          console.log(e)
        });
    },


    copy(){
      var copyTextarea = this.$refs.copiar
      copyTextarea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'sim!' : 'não!';
        // alert('Link copiado? ' + msg);
        alert(this.link);
      } catch (err) {
        alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
      }
    },


  },

}
</script>


// WEBPACK FOOTER //
// src/components/teste/teste.vue